import { styled } from '@mui/joy';
import Input from '@mui/joy/Input';

import { commonBaseInputStyles } from '@components/BaseStyledComponents/common';

export const BaseInput = styled(Input)(({ theme }) => ({
  ...commonBaseInputStyles(theme),
}));
